import { useEffect, useMemo, useRef, useState } from "react";

import { useRtl } from "@ryde/redux";
import { useIsMobile } from "@ryde/shared";

import { FloatingMenuType, floatingPanelSizes } from "./floating-menu.models";

export const useFloatMenu = ({
  page,
  isCentering = true,
  isOpened,
}: {
  page: FloatingMenuType;
  isCentering?: boolean;
  isOpened: boolean;
}) => {
  const { isRtl } = useRtl();
  const { isMobile } = useIsMobile();
  const menuSizes = useMemo(() => {
    return floatingPanelSizes[page][isMobile ? "mobile" : "desktop"];
  }, [isMobile, page]);
  const floatingMenuRef = useRef<HTMLDivElement>(null);

  const [leftX, setLeftX] = useState(menuSizes.LEFT);
  const [bottomY, setBottomY] = useState(menuSizes.BOTTOM);
  const [isAllowedInitCentering, setIsAllowedInitCentering] = useState(false);
  const [isInitFinished, setIsInitFinished] = useState(false);

  useEffect(() => {
    if (!isOpened) {
      return;
    }

    if (!isCentering) {
      return;
    }

    if (!floatingMenuRef.current) {
      return;
    }

    if (page === "bookingsCalendar" && !isAllowedInitCentering) {
      return;
    }

    const parentElement = floatingMenuRef.current.parentElement;

    if (!parentElement) {
      return;
    }

    const { width: parentWidth } = parentElement.getBoundingClientRect();
    const { width: floatingMenuRefWidth } =
      floatingMenuRef.current.getBoundingClientRect();
    const centerX = parentWidth / 2 - floatingMenuRefWidth / 2;
    setLeftX(isRtl ? -centerX : centerX);

    setIsInitFinished(true);
  }, [isAllowedInitCentering, isCentering, isOpened, isRtl, page]);

  return {
    leftX,
    bottomY,
    setLeftX,
    setBottomY,
    floatingMenuRef,
    isInitFinished,
    setIsAllowedInitCentering,
  };
};
